import {RechargeCommissionRuleV2} from '../invitation.type';
import {getAgentCommissionRuleGroup} from './commission-rule.utils';

export interface GameCommissionDisplayItem {
  gameType: number;
  gameTypeName: string;
  commissionRate: string;
  level1Rate: string;
  level2Rate: string;
  level3Rate: string;
}

export const getGameCommissionDisplayList = (
  ruleGroups: RechargeCommissionRuleV2[] | undefined,
  agentLevel: number | undefined,
): GameCommissionDisplayItem[] => {
  const group = getAgentCommissionRuleGroup(ruleGroups, agentLevel);

  return (group?.gameList || []).map(game => ({
    gameType: game.gameType,
    gameTypeName: game.gameTypeName,
    commissionRate: game.level1Rate || '-',
    level1Rate: game.level1Rate || '-',
    level2Rate: game.level2Rate || '-',
    level3Rate: game.level3Rate || '-',
  }));
};
